import React from 'react';
import { observer } from 'mobx-react-lite';
import { Results } from '@pascal/pascal-core/table-line/table-components/results';
import ResultRow from '../resultRow';

const ResultWr = observer(({ isShowResultTitles, resultTitles }) => {
  return (
    <Results
      collRenderer={(result) => <ResultRow key={result.roundId} result={result} />}
      isShowResultTitles={isShowResultTitles}
      resultTitles={resultTitles}
    />
  );
});

export default ResultWr;
